import React, { useMemo } from 'react'
import SitemodelModal from 'component/SitemodelModal/SitemodelModal'
import { SelectAndLinkSession } from './SelectAndLink.types'
import { buildSelectAndLinkIframeUrl } from './utils/buildSelectAndLinkIframeUrl'

type SelectAndLinkCardProps = {
  title: React.ReactNode
  session: SelectAndLinkSession
  onClose: () => void
  zIndex?: number
}

function SelectAndLinkCard({
  title,
  session,
  onClose,
  zIndex
}: SelectAndLinkCardProps) {
  const iframeUrl = useMemo(
    () => buildSelectAndLinkIframeUrl(session),
    [session]
  )

  return (
    <SitemodelModal
      title={title}
      completeURL={iframeUrl}
      zIndex={zIndex}
      guardCloseWhileSelectAndLinkOpen={false}
      onClose={onClose}
    />
  )
}

export default SelectAndLinkCard
